import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  padding-right: 24px;
`;

export const BannerLeft = ({ children }) => (
  <LeftContainer className='banner-left-container'>
    {children}
  </LeftContainer>
);

BannerLeft.propTypes = {
  children: PropTypes.node.isRequired,
}